import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { decorateWith, withName } from 'helpers/decorator';
import { isEmpty } from 'helpers/verify';
import { selectCmsPath } from 'redux/saga/selectors/cms';
export var mapStateToProps = function mapStateToProps(state) {
  return {
    path: selectCmsPath(state)
  };
};
export var mapDispatchToProps = {
  // We need to map dispatch for compatibility reasons
  // in the short term. It will be removed in the near future
  // as we make modules connected.
  dispatch: function dispatch(obj) {
    return obj;
  }
};
export var CmsModulesUnwrapped =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CmsModulesUnwrapped, _React$Component);

  function CmsModulesUnwrapped() {
    _classCallCheck(this, CmsModulesUnwrapped);

    return _possibleConstructorReturn(this, _getPrototypeOf(CmsModulesUnwrapped).apply(this, arguments));
  }

  _createClass(CmsModulesUnwrapped, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dispatch = _this$props.dispatch,
          modules = _this$props.modules,
          path = _this$props.path;

      if (isEmpty(modules)) {
        return null;
      }

      return modules.map(function (_ref, index) {
        var Component = _ref.Component,
            cmsModuleId = _ref.cmsModuleId,
            props = _ref.props;
        return React.createElement("div", {
          "data-cms-module-id": cmsModuleId,
          key: "".concat(Component.displayName, "_").concat(index) // eslint-disable-line react/no-array-index-key

        }, React.createElement(Component, _extends({
          cmsModuleId: cmsModuleId,
          path: path
        }, props, Component.handlerMapper ? Component.handlerMapper(dispatch) : {})));
      });
    }
  }]);

  return CmsModulesUnwrapped;
}(React.Component);
export var CmsModuleShape = PropTypes.shape({
  cmsModuleId: PropTypes.string.isRequired,
  Component: PropTypes.func.isRequired,
  props: PropTypes.object.isRequired
});
CmsModulesUnwrapped.propTypes = {
  dispatch: PropTypes.func,
  modules: PropTypes.arrayOf(CmsModuleShape),
  path: PropTypes.string
};
export var CmsModules = decorateWith(connect(mapStateToProps, mapDispatchToProps), withName('CmsModules'))(CmsModulesUnwrapped);